// @ts-nocheck
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { usePageNavigation } from 'hooks/pageNavigation';

import ErrorPage from 'components/pages/Error';

const messages = {
  networkError: {
    id: 'error.message.network',
    description: 'syncbak error',
  },
};

const NetworkError = () => {
  const intl = useIntl();
  const { navigateToHome } = usePageNavigation();

  const networkError = intl.formatMessage(messages.networkError);

  const networkConnected = useSelector(state => state.network.networkConnected);
  const previouslyConnected = useSelector(
    state => state.network.previouslyConnected,
  );

  useEffect(() => {
    if (networkConnected && !previouslyConnected) {
      navigateToHome();
    }
  }, [networkConnected, navigateToHome, previouslyConnected]);

  return (
    <ErrorPage
      message={
        <React.Fragment>
          <div>{networkError}</div>
        </React.Fragment>
      }
    />
  );
};

export default NetworkError;
